import { render, staticRenderFns } from "./bandeau-totaux.vue?vue&type=template&id=8742cc00"
import script from "./bandeau-totaux.vue?vue&type=script&lang=js"
export * from "./bandeau-totaux.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports